export default {
  demo: '/v3/third/partner/url'
}
